module.exports = __webpack_public_path__ + "img/girl.232d90fb.png";